import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "./chunk-CJ2S4EJP.js";
import {
  Button
} from "./chunk-QXEA2YZ6.js";
import {
  Icon
} from "./chunk-7IEFGXFA.js";
import {
  cn
} from "./chunk-SBEJSA5Q.js";

// src/components/canvas/editor/sidebar/CanvasSidebarCredits.tsx
import { useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var formatBalance = (value) => `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
var CanvasCreditsPanel = ({ balance, isLowBalance, isLoading, error, refetch, onTopUp, onBilling }) => {
  const [isOpen, setIsOpen] = useState(false);
  const numericBalance = balance === null ? NaN : Number.parseFloat(balance);
  const available = !isLoading && !error && Number.isFinite(numericBalance);
  const empty = available && numericBalance <= 0;
  const low = available && !empty && isLowBalance;
  const unavailable = !isLoading && !available;
  const amount = available ? formatBalance(numericBalance) : "\u2014";
  const status = isLoading ? "Loading credits" : unavailable ? "Balance unavailable" : empty ? "No credits" : low ? "Running low" : "Credits";
  const topUp = () => {
    setIsOpen(false);
    onTopUp();
  };
  return /* @__PURE__ */ jsxs(Popover, { open: isOpen, onOpenChange: setIsOpen, children: [
    /* @__PURE__ */ jsx(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        "aria-label": available ? `Credits: ${amount}. ${status}` : status,
        className: cn(
          "flex h-5 shrink-0 items-center gap-1.5 whitespace-nowrap rounded px-1.5 text-xs transition-colors hover:bg-accent active:bg-accent/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring data-[state=open]:bg-accent",
          low && "text-yellow-500",
          (empty || unavailable) && "text-destructive"
        ),
        children: [
          /* @__PURE__ */ jsx(Icon, { name: isLoading ? "loader-2" : empty || low || unavailable ? "alert-triangle" : "wallet", className: cn("size-3.5 shrink-0", isLoading && "animate-spin motion-reduce:animate-none") }),
          /* @__PURE__ */ jsx("span", { className: "tabular-nums", children: amount }),
          /* @__PURE__ */ jsx("span", { children: status }),
          /* @__PURE__ */ jsx(Icon, { name: isOpen ? "chevron-down" : "chevron-up", className: "size-3 shrink-0" })
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs(PopoverContent, { side: "top", align: "start", sideOffset: 8, collisionPadding: 12, "aria-label": "Credits", className: "w-72 max-w-[calc(100vw-24px)] rounded-lg shadow-float p-0", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex h-9 items-center justify-between pl-3 pr-1.5", children: [
        /* @__PURE__ */ jsx("h2", { className: "text-sm font-medium", children: "Credits" }),
        /* @__PURE__ */ jsx(Button, { type: "button", variant: "ghost", size: "icon-xs", "aria-label": "Close credits", onClick: () => setIsOpen(false), children: /* @__PURE__ */ jsx(Icon, { name: "x", className: "size-3.5" }) })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-3 max-h-[50vh] overflow-y-auto px-3 pb-3 pt-1 genie-scroll", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1", "aria-live": "polite", children: [
          /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Wallet balance" }),
          /* @__PURE__ */ jsx("p", { className: cn("text-xl font-semibold tabular-nums", low && "text-yellow-500", empty && "text-destructive"), children: amount }),
          isLoading && /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Loading balance\u2026" })
        ] }),
        (low || empty) && /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 rounded-md bg-yellow-500/10 border border-yellow-500/20 px-2.5 py-2", children: [
          /* @__PURE__ */ jsx(Icon, { name: "alert-triangle", className: "size-3.5 text-yellow-500 shrink-0" }),
          /* @__PURE__ */ jsx("p", { className: "text-xs text-yellow-600 dark:text-yellow-400", children: empty ? "No credits remaining." : "Balance is running low." })
        ] }),
        unavailable && /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between gap-2", role: "alert", children: [
          /* @__PURE__ */ jsx("span", { className: "text-xs text-destructive", children: "Failed to load balance" }),
          /* @__PURE__ */ jsx(Button, { type: "button", variant: "ghost", size: "sm", className: "h-6 px-2 text-xs", onClick: refetch, children: "Retry" })
        ] }),
        /* @__PURE__ */ jsxs(Button, { type: "button", variant: "outline", size: "sm", className: "w-full text-xs", onClick: topUp, children: [
          /* @__PURE__ */ jsx(Icon, { name: "plus", className: "size-3.5 mr-1.5" }),
          "Add credits"
        ] }),
        onBilling && /* @__PURE__ */ jsxs(Button, { type: "button", variant: "ghost", size: "sm", className: "w-full text-xs", onClick: () => {
          setIsOpen(false);
          onBilling();
        }, children: [
          /* @__PURE__ */ jsx(Icon, { name: "settings", className: "size-3.5 mr-1.5" }),
          "Billing settings"
        ] }),
        /* @__PURE__ */ jsx("p", { className: "text-[11px] text-muted-foreground", children: "Pay-as-you-go \u2014 charged per generation" })
      ] })
    ] })
  ] });
};

export {
  CanvasCreditsPanel
};
//# sourceMappingURL=chunk-5ZFMIS6R.js.map